import { KoncentroBaseModel } from './koncentro-base.model';

export class AnalyticsSystem extends KoncentroBaseModel {
  public dto = 'AnalyticsDto';

  public id?: number;
  public code: string;
  public name: string;
  public description: string;
  public img_b64: string;
  public img_url: string;
  public flg_state: number;
}



// WEBPACK FOOTER //
// ./src/app/models/analytics-system.model.ts